import React, {useState, useEffect,useRef} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import photo from "../../components/landingPage/images/Capture.png"


const LoginSection = (props) => {
    const [isActive, setIsActive] = useState(false);
    const [city, setCity] = useState([]);
    const [state, setState] = useState({});
    const [click, setClick] = useState(false);
    const [phone,setPhone] = useState()
    const [name,setName] = useState()
    const inputRef = useRef();
    const nameRef = useRef();
    const type = props.type;
    const navigate = useNavigate();
    const id = props.id;

    useEffect(()=>{
        const validatedPhone = state.prefix + state.numbers;
        if(/^\+?((972|0)|(970|0))(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/.test(validatedPhone)) {
            setState({...state,phone:validatedPhone});
            inputRef.current.setCustomValidity("")
            inputRef.current.reportValidity()
        }
        else{
            if(validatedPhone){
                inputRef.current.setCustomValidity("تأكد من اختيار المقدمة,يجب ان يحتوي الرقم على 9 ارقام غير مبدوء بالصفر")
                inputRef.current.reportValidity()
            }
        }
    },[phone])
    useEffect(()=>{
        const validatedName = state.name ;
        if(/^[\u0621-\u064A ]+$/.test(validatedName)&&validatedName.length>=3) {
            setState({...state,name:validatedName});
            nameRef.current.setCustomValidity("")
            nameRef.current.reportValidity()
        }
        else{
            if(validatedName){
                nameRef.current.setCustomValidity("يجب ان يحتوي الاسم على 3 احرف على الاقل باللغةالعربية بدون ارقام او اي رموز")
                nameRef.current.reportValidity()
            }
        }
    },[name])

    const onChange = (e) => {
        if(e.target.name  === 'numbers' || e.target.name==='prefix'){
            setPhone(state.prefix + state.numbers)
        }
        if(e.target.name  === 'name'){
            setName(state.name)
        }
        setState({...state, [e.target.name]: e.target.value});
    };
    const currentDate = new Date();
    const handleClick = (e) => {
        e.preventDefault();
        setIsActive((current) => !current);
        const validatedName = state.name ;
        const userData = {
            name: state.name,
            quantity: state.quantity,
            residency: state.residency,
            gender: state.gender,
            typeOfEvent: state.typeOfEvent,
            date: state.date,
            text: state.text,
            location:state.location,
            accepted:state.accepted,
            businessId:id,
            phone:state.phone,
            businessType:type,
            creationDate:currentDate,
            is_notified_paid:state.is_notified_paid,
            is_paid:state.is_paid,
            paid_amount:state.paid_amount,
            timeRunOut:state.timeRunOut,
            token:state.token,
            userUid:state.userUid,
            zifaf_dues:state.zifaf_dues,
            productId:state.productId,

        };
        if(/^[\u0621-\u064A ]+$/.test(validatedName)&&validatedName.length>=3) {
            console.log(userData)
            axios
                .post(
                    `https://us-central1-zifaf-app.cloudfunctions.net/webapp/api/login/${type}/${id}`,
                    userData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err.message);
                });
            setClick(true);
            setTimeout(() => navigate("/"), 1000);
        }
        else{
            if(validatedName){
                nameRef.current.setCustomValidity("يجب ان يحتوي الاسم على 3 احرف على الاقل باللغةالعربية بدون ارقام او اي رموز")
                nameRef.current.reportValidity()
            }
        }
    };
    useEffect(() => {
        axios({
            method: "get",
            url: `https://us-central1-zifaf-app.cloudfunctions.net/webapp/api/login`,
            responseType: "json",
        }).then((response) => {
            setCity(response.data.Cities);
        });
    }, []);

    return (
        <div className="login">
            <p>حابين نسألك كم سؤال قبل ما نبلش </p>
            <form onSubmit={handleClick} className="login-section">
                <div className="user-form">
                    <div className="login-icon"></div>
                    <div className="user-name-and-calender">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="33"
                            height="33"
                            viewBox="0 0 33 33"
                            fill="none"
                        >
                            <path
                                d="M16.7518 8.81371C18.2949 8.81371 19.5454 10.0642 19.5454 11.6073C19.5454 13.1505 18.2949 14.401 16.7518 14.401C15.2086 14.401 13.9582 13.1505 13.9582 11.6073C13.9582 10.0642 15.2086 8.81371 16.7518 8.81371ZM16.7518 20.7864C20.7028 20.7864 24.8666 22.7287 24.8666 23.5801V25.0434H8.63695V23.5801C8.63695 22.7287 12.8008 20.7864 16.7518 20.7864ZM16.7518 6.28613C13.8118 6.28613 11.4306 8.66737 11.4306 11.6073C11.4306 14.5473 13.8118 16.9285 16.7518 16.9285C19.6918 16.9285 22.073 14.5473 22.073 11.6073C22.073 8.66737 19.6918 6.28613 16.7518 6.28613ZM16.7518 18.2589C13.1999 18.2589 6.10938 20.0415 6.10938 23.5801V27.571H27.3942V23.5801C27.3942 20.0415 20.3037 18.2589 16.7518 18.2589Z"
                                fill="#666666"
                            />
                        </svg>
                        <input
                            type="text"
                            name="name"
                            required
                            value={state.name|| ''}
                            onChange={onChange}
                            placeholder="الإسم بالعربية؟"
                            ref={nameRef}
                        />
                    </div>
                    <div
                        className="user-name-and-calender">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="33"
                            height="33"
                            viewBox="0 0 33 33"
                            fill="none"
                        >
                            <path
                                d="M16.7518 8.81371C18.2949 8.81371 19.5454 10.0642 19.5454 11.6073C19.5454 13.1505 18.2949 14.401 16.7518 14.401C15.2086 14.401 13.9582 13.1505 13.9582 11.6073C13.9582 10.0642 15.2086 8.81371 16.7518 8.81371ZM16.7518 20.7864C20.7028 20.7864 24.8666 22.7287 24.8666 23.5801V25.0434H8.63695V23.5801C8.63695 22.7287 12.8008 20.7864 16.7518 20.7864ZM16.7518 6.28613C13.8118 6.28613 11.4306 8.66737 11.4306 11.6073C11.4306 14.5473 13.8118 16.9285 16.7518 16.9285C19.6918 16.9285 22.073 14.5473 22.073 11.6073C22.073 8.66737 19.6918 6.28613 16.7518 6.28613ZM16.7518 18.2589C13.1999 18.2589 6.10938 20.0415 6.10938 23.5801V27.571H27.3942V23.5801C27.3942 20.0415 20.3037 18.2589 16.7518 18.2589Z"
                                fill="#666666"
                            />
                        </svg>
                        <input
                            name="numbers"
                            type="text"
                            required
                            onChange={onChange}
                            placeholder="رقم التلفون؟"
                            value={state.numbers|| ''}
                            ref={inputRef}
                        />
                        <select
                            name="prefix"
                            required={true}
                            className="required"
                            onChange={onChange}
                            value={state.prefix}
                        >
                            <option value="">المقدمة</option>
                            <option  value="+972">972+</option>
                            <option value="+970">970+</option>
                        </select>
                    </div>
                    <div className="party-place">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="33"
                            height="33"
                            viewBox="0 0 33 33"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M25.8451 1.46239L25.889 2.39938L26.9629 2.44019C27.5537 2.46254 28.0369 2.51918 28.0369 2.56582C28.0369 2.65591 24.8711 5.51118 24.0769 6.13737L23.6066 6.50814L22.7794 5.87681C21.765 5.10251 21.1699 4.81197 19.7395 4.39289C18.1189 3.91787 16.1017 3.94591 14.4824 4.46577C12.5137 5.09765 10.7873 6.33087 9.78161 7.82382C9.4292 8.34687 9.38031 8.36991 8.54142 8.40545C5.74326 8.52428 3.15102 9.93074 1.52507 12.2124C0.106219 14.2034 -0.291824 17.0768 0.539223 19.3294C1.66669 22.3856 4.01584 24.2684 7.6366 25.0179L8.04945 25.1034L8.00694 26.3834L7.96442 27.6635L6.44602 27.7031L4.92762 27.7427V28.7047V29.6666L6.44602 29.7062L7.96442 29.7458L8.00679 31.0992L8.04916 32.4526H9.08078H10.1124V31.0692V29.6858L11.7049 29.6464L13.2973 29.6069L13.341 28.6747L13.3847 27.7425L11.7856 27.703L10.1865 27.6635L10.144 26.3834L10.1014 25.1034L10.5143 25.0178C11.4699 24.8197 12.7555 24.3717 13.4689 23.9882C14.4534 23.459 15.9059 22.1971 16.4368 21.4096C16.8175 20.8449 16.9034 20.7927 17.4549 20.7925C19.9796 20.7914 22.9825 19.3143 24.4415 17.3555C25.6719 15.7037 26.1263 14.3699 26.1255 12.4119C26.1249 11.05 25.9042 10.0143 25.3973 8.99305C25.1889 8.57314 25.0142 8.18654 25.0092 8.13407C24.9976 8.01247 29.7024 3.85707 29.8516 3.85693C29.9128 3.85693 29.9627 4.35666 29.9627 4.96744V6.07795H30.9997H32.0366V3.30167V0.525391H28.9189H25.8014L25.8451 1.46239ZM19.0722 6.24495C20.5151 6.58435 22.1644 7.72651 23.0185 8.97792C23.7826 10.0977 24.078 11.2095 24.0122 12.7192C23.9621 13.8693 23.8869 14.1937 23.482 15.0025C22.4494 17.0656 20.6882 18.3419 18.3007 18.7574L17.8229 18.8405L17.9096 17.3524C18.0168 15.5091 17.7718 14.4182 16.8959 12.8406C16.0488 11.3149 14.6916 10.0659 13.0154 9.26943C11.5758 8.58549 11.5727 8.56772 12.7252 7.61699C14.4469 6.19706 16.7511 5.69885 19.0722 6.24495ZM8.45268 10.9712C8.26381 11.7305 8.40439 14.0054 8.6934 14.8645C9.39231 16.9428 11.2454 18.9678 13.2973 19.8959C13.9491 20.1906 14.5158 20.4562 14.5565 20.486C14.5972 20.5159 14.227 20.8961 13.7339 21.3311C10.9313 23.8031 6.88169 23.7591 4.18442 21.2273C1.59959 18.8008 1.54729 14.8756 4.0665 12.3794C4.49714 11.9528 5.13679 11.446 5.48817 11.2531C6.225 10.8484 7.63734 10.3995 8.20796 10.3887C8.59356 10.3813 8.59726 10.3902 8.45268 10.9712ZM12.2211 11.0943C14.5766 12.2013 16.1099 14.8647 15.8253 17.3548C15.6872 18.5628 15.6176 18.6445 14.9074 18.4327C12.9621 17.8527 11.058 15.8367 10.5659 13.836C10.3697 13.0393 10.3702 11.6966 10.5666 11.0339C10.7464 10.4267 10.8054 10.4289 12.2211 11.0943Z"
                                fill="#666666"
                            />
                        </svg>
                        <select
                            required={true}
                            className="required"
                            value={state.gender}
                            name="gender"
                            onChange={onChange}
                        >
                            <option value="0">عروس \ عريس؟</option>
                            <option value="عروس">عروس</option>
                            <option value="عريس">عريس</option>
                        </select>
                    </div>
                    <div className="user-name-and-calender">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="33"
                            height="33"
                            viewBox="0 0 33 33"
                            fill="none"
                        >
                            <path
                                d="M16.7518 8.81371C18.2949 8.81371 19.5454 10.0642 19.5454 11.6073C19.5454 13.1505 18.2949 14.401 16.7518 14.401C15.2086 14.401 13.9582 13.1505 13.9582 11.6073C13.9582 10.0642 15.2086 8.81371 16.7518 8.81371ZM16.7518 20.7864C20.7028 20.7864 24.8666 22.7287 24.8666 23.5801V25.0434H8.63695V23.5801C8.63695 22.7287 12.8008 20.7864 16.7518 20.7864ZM16.7518 6.28613C13.8118 6.28613 11.4306 8.66737 11.4306 11.6073C11.4306 14.5473 13.8118 16.9285 16.7518 16.9285C19.6918 16.9285 22.073 14.5473 22.073 11.6073C22.073 8.66737 19.6918 6.28613 16.7518 6.28613ZM16.7518 18.2589C13.1999 18.2589 6.10938 20.0415 6.10938 23.5801V27.571H27.3942V23.5801C27.3942 20.0415 20.3037 18.2589 16.7518 18.2589Z"
                                fill="#666666"
                            />
                        </svg>
                        <input
                            type="number"
                            min="1"
                            required
                            name="quantity"
                            onChange={onChange}
                            placeholder="عدد المعازيم؟"
                        />
                    </div>

                    <div className="party-place">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="33"
                            viewBox="0 0 24 33"
                            fill="none"
                        >
                            <path
                                d="M11.729 1.13184C5.47748 1.13184 0.421387 6.18793 0.421387 12.4394C0.421387 19.1755 7.56131 28.4638 10.5013 32.0015C11.1474 32.7769 12.3266 32.7769 12.9728 32.0015C15.8966 28.4638 23.0365 19.1755 23.0365 12.4394C23.0365 6.18793 17.9804 1.13184 11.729 1.13184ZM11.729 16.4778C9.49975 16.4778 7.69054 14.6686 7.69054 12.4394C7.69054 10.2102 9.49975 8.40098 11.729 8.40098C13.9582 8.40098 15.7674 10.2102 15.7674 12.4394C15.7674 14.6686 13.9582 16.4778 11.729 16.4778Z"
                                fill="#666666"
                            />
                        </svg>
                        <select
                            className="required"
                            value={state.location}
                            onChange={onChange}
                            name="location"
                            required={true}
                        >
                            <option value="0">مكان الحفلة؟</option>
                            {Object.keys(city).map((key) => (
                                <option key={key} value={city[key]}>
                                    {city[key]}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="party-place">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="33"
                            viewBox="0 0 24 33"
                            fill="none"
                        >
                            <path
                                d="M11.729 1.13184C5.47748 1.13184 0.421387 6.18793 0.421387 12.4394C0.421387 19.1755 7.56131 28.4638 10.5013 32.0015C11.1474 32.7769 12.3266 32.7769 12.9728 32.0015C15.8966 28.4638 23.0365 19.1755 23.0365 12.4394C23.0365 6.18793 17.9804 1.13184 11.729 1.13184ZM11.729 16.4778C9.49975 16.4778 7.69054 14.6686 7.69054 12.4394C7.69054 10.2102 9.49975 8.40098 11.729 8.40098C13.9582 8.40098 15.7674 10.2102 15.7674 12.4394C15.7674 14.6686 13.9582 16.4778 11.729 16.4778Z"
                                fill="#666666"
                            />
                        </svg>
                        <select
                            className="required"
                            name="typeOfEvent"
                            value={state.typeOfEvent}
                            onChange={onChange}
                        >
                            <option value="0">نوع الحفلة؟</option>
                            <option value="عرس">عرس</option>
                            <option value="خطبة">خطبة</option>
                            <option value="حفلات تخرج">حفلات تخرج</option>
                        </select>
                    </div>
                    <div
                        className="user-name-and-calender calender"
                        onChange={(e) => onChange(e)}
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => (e.target.type = "text")}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="23"
                            height="26"
                            viewBox="0 0 23 26"
                            fill="none"
                        >
                            <path
                                d="M20.6015 3.14783H19.4929V0.930664H17.2757V3.14783H6.1899V0.930664H3.97273V3.14783H2.86414C1.6447 3.14783 0.646973 4.14556 0.646973 5.365V23.1024C0.646973 24.3218 1.6447 25.3195 2.86414 25.3195H20.6015C21.8209 25.3195 22.8187 24.3218 22.8187 23.1024V5.365C22.8187 4.14556 21.8209 3.14783 20.6015 3.14783ZM20.6015 23.1024H2.86414V8.69076H20.6015V23.1024Z"
                                fill="#666666"
                            />
                        </svg>
                        <input
                            type="text"
                            name="date"
                            placeholder="موعد الحفلة؟"
                            onChange={onChange}
                            required
                        />
                    </div>
                    <div className="other-details">
                        <input
                            type="text"
                            name="text"
                            onChange={onChange}
                            placeholder="تفاصيل أخرى"
                        />
                    </div>
                    {click ? (
                        <div className="login-show-price">
                            <button
                                style={{
                                    backgroundColor: isActive ? "#45A89E" : "",
                                    color: isActive ? "white" : "",
                                }}
                            >
                                <i className="fa fa-circle-o-notch fa-spin"></i> طلبك قيد
                                التنفيذ
                            </button>
                        </div>
                    ) : (
                        <div className="login-show-price">
                            <button
                                style={{
                                    backgroundColor: isActive ? "#45A89E" : "",
                                    color: isActive ? "white" : "",
                                }}
                            >
                                طلب عرض سعر
                            </button>
                        </div>
                    )}
                </div>
                <div className="img-login-wrapper"
                     style={{ backgroundImage: `url("${photo}")` }}
                ></div>
            </form>
        </div>
    );
};

export default LoginSection;
